<template>
    <div class="the-header">
        <img :src="this.$projectPath + '/image/robot.png'"/>
        <span class="title"><span class="bigger"></span>行政审批智能助手(试运行) </span>
    </div>
</template>

<script>
export default {
    name: "the-header",
    mixins: [],
    props: {},
    components: {},
    data() {
        return {

        }
    },
    methods: {},
    mounted() { }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';
.the-header {
    height: $headerHeight;
    color: rgba(69, 125, 255, 1);
    font-size: 32px;
    display: flex;
    align-items: flex-start;
    font-weight: bold;
    img {
        position: relative;
        z-index: 99999;
        transform: translateY(-40px);
    }

    .title {
        display: flex;
        align-items: center;
    }

    .bigger {
        font-size: 38px;
        transform: translateY(3px);
    }
}
</style>
